import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const benefitRows = [['✅ 6 Premium Volumes', '✅ 5 Bonus Kits'], ['✅ 50+ Choreography Drills', '✅ 12-Week Class Programs'], ['✅ Done-For-You Class Plans', '✅ 100% Printable Resources']];
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/xuP7XtHkhfYLZKT5s2swPH/Mockup_step.png';
export function Hero() {
  return <>
      <section className="w-full bg-sky px-4 py-4 text-ink sm:py-6" data-id="element-109" data-mp="128fo9ew4a5tl">
        <div className="mx-auto max-w-5xl text-center" data-id="element-110" data-mp="xanqw5cpdri0">
          <motion.span initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45
        }} className="inline-flex rounded-full border border-sky-line bg-surface px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-teal" data-id="element-111" data-mp="xb5qnbykqnuo">
            🏃 The #1 System for Step Instructors
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.05
        }} className="mx-auto mt-3 max-w-3xl font-display text-4xl font-extrabold leading-[0.98] tracking-tight text-ink sm:text-6xl" data-id="element-112" data-mp="3814cxsua24px">
            Step Class Ready™
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.12
        }} className="mt-2 font-display text-lg font-semibold text-slate sm:text-xl" data-id="element-113" data-mp="3e8mqutk3wdbz">
            Professional step classes. Ready to teach.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.16
        }} className="mx-auto mt-3 max-w-md text-sm leading-snug text-slate sm:text-base" data-id="element-114" data-mp="2qlod43ndfjhr">
            Ready-to-teach class plans, step sequences, choreography drills, and printable resources for professional
            step instructors.
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.2
        }} className="mx-auto mt-5 max-w-3xl text-center" data-id="element-115" data-mp="nbl2il2gggag">
            <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-teal sm:text-xs" data-id="element-116" data-mp="degeefp1uar0">
              📦 Everything You Get Instantly
            </p>
            <div className="mt-1.5 space-y-0.5 text-[11px] font-medium text-slate sm:text-xs" data-id="element-117" data-mp="1622j5ra0jlfg">
              {benefitRows.map(row => <p key={row.join('-')} className="flex flex-wrap justify-center gap-x-4 gap-y-0.5" data-id="element-118" data-mp="111eql164ywj4">
                  {row.map(benefit => <span key={benefit} data-id="element-119" data-mp="3lsysay1o8kij">{benefit}</span>)}
                </p>)}
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.26
        }} className="mx-auto mt-5 max-w-3xl" data-id="element-120" data-mp="3hqkamh9qnqsu">
            <img src={mockupUrl} alt="Step Class Ready complete system — six printable volumes and digital drill bank" className="mx-auto block h-auto w-full max-w-2xl rounded-3xl object-contain shadow-elevated" data-id="element-121" data-mp="218to7r4wn2cr" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.32
        }} className="mt-5" data-id="element-122" data-mp="2fzj1r05u8tjs">
            <CTAButton href="#complete-package" pulse size="large" data-id="element-123" data-mp="2p1a9eajxvaga">
              Get Instant Access
            </CTAButton>
            <p className="mx-auto mt-3 max-w-3xl text-xs leading-relaxed text-slate sm:text-sm" data-id="element-124" data-mp="umhe6cmywlov">
              📄 High-Quality PDF <span className="mx-1" data-id="element-125" data-mp="zl11agdas3it">·</span> 🖨️ Printable Resources <span className="mx-1" data-id="element-126" data-mp="znn6i9cpu6xv">·</span>{' '}
              ⚡ Instant Download <span className="mx-1" data-id="element-127" data-mp="4a2ulkgef9zm">·</span> 🔒 Secure Payment <span className="mx-1" data-id="element-128" data-mp="3vhp4vvxmiapg">·</span> 🛡️
              7-Day Guarantee
            </p>
          </motion.div>
        </div>
      </section>
      <section className="border-y border-sky-line bg-surface px-4 py-5 text-ink" data-id="element-129" data-mp="e8io1u2wevca">
        <div className="mx-auto max-w-3xl text-center" data-id="element-130" data-mp="9a7d1g0vaesh">
          <p className="text-sm font-bold sm:text-base" data-id="element-131" data-mp="98e7k41zq0m2">
            🚀 Launch offer active — Price increases when the timer hits zero
          </p>
          <div className="mx-auto mt-3 h-2 max-w-xl overflow-hidden rounded-full bg-green-soft" data-id="element-132" data-mp="3crz2amnmckmz">
            <div className="h-full w-[68%] rounded-full bg-green" data-id="element-133" data-mp="3rgbvxcz8hreb" />
          </div>
          <p className="mt-2 text-xs font-medium text-slate" data-id="element-134" data-mp="3motwwugru0vz">68% of launch spots already claimed</p>
        </div>
      </section>
    </>;
}